// extracted by mini-css-extract-plugin
export default {"sellOfferCancelConetent":"s_u_8yVos7WpBiHyMpgB","sellOfferCancelAvailableXlm":"mdChxjJMgwMGLSb5kDmz"};